import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { generateLink, openLink } from "@shared/utils/helpers";
import { StepNavigationButtons } from "@entities/StepNavigationButtons/StepNavigationButtons";

import { Container, Loader, Paper, Stack, Text } from "@mantine/core";
import { useParams } from "react-router-dom";
import { isDevelopmentServer } from "@/api/OpenApiClient";
import { persistStore } from "@entities/StepFolder/store/persistStore";
import { appStore } from "@/app/store/appStore";

interface AuthenticationResult {
	refreshToken: string | null | undefined;
	error: string | null | undefined;
	autoLogin?: boolean;
	title?: string | null;
}

const OauthRenderer: React.FC<AuthenticationResult> = ({ refreshToken, error, autoLogin, title }) => {
	const { t } = useTranslation();

	const [deep, setDeep] = useState<string>("");
	const [link, setLink] = useState<string>("");
	const { mode } = useParams<{ mode: string }>(),
		launcherMode = mode === "launcher";

	const { appCode } = appStore((state) => ({
		appCode: state.appCode
	}));
	const openLauncher = useCallback(
		(refreshToken: string) => {
			const params = `#fxid-auth-token=${refreshToken}`;
			const deeplink = generateLink(true,params);
			setDeep(deeplink);
			const weblink = generateLink(false, params,true);
			setLink(weblink);
			if (autoLogin) {
				window.location.href = launcherMode ? deeplink : weblink;
			}
		},
		[launcherMode, autoLogin]
	);

	useEffect(() => {
		if (refreshToken) {
			openLauncher(refreshToken);
		}
	}, [refreshToken, openLauncher]);

	if (error) {
		return (
			<Container size="xs" py="xl">
				<Paper shadow="md" p="md" radius="md" withBorder>
					<Text c="red">{error}</Text>
				</Paper>
			</Container>
		);
	}

	return (
		<>
			<Container size="xs" py="xl">
				{refreshToken ? (
					<Paper shadow="md" p="md" radius="md" withBorder>
						<Stack align="center">
							{title && <Text variant="h4">{title}</Text>}
							<StepNavigationButtons
								backText={t("common.StayOnWeb", "Continue on the web")}
								backOnClick={() => openLink(link)}
								backIsDisabled={false}
								nextText={t("common.OpenLauncher", "Open launcher")}
								nextOnClick={() => openLink(deep)}
								nextIsDisabled={false}
							/>
						</Stack>
						{/*{isDevelopmentServer() && <Text>{JSON.stringify({recall: persistStore.getState().stateAfterOauth,web:link})}</Text>}*/}
					</Paper>
				) : (
					<Loader />
				)}
			</Container>
		</>
	);
};
export default OauthRenderer;
